import { put, takeEvery } from "redux-saga/effects";

import { versionsGetError, versionsGetStart, versionsGetSuccess } from "Store/Actions";
import { getVersions } from "API/Versions";
import { callWithAuth } from "./CallWithAuth";

function* versionsGetStartSaga() {
  try {
    const versions: Record<string, string> = yield callWithAuth(getVersions);
    yield put(versionsGetSuccess(versions));
  } catch (error) {
    console.error(error);
    yield put(versionsGetError(error));
  }
}

export function* VersionsSaga(): unknown {
  yield takeEvery(versionsGetStart, versionsGetStartSaga);
}
